export default __webpack_public_path__ + "static/media/0x2934b36ca9a4b31e633c5be670c8c8b28b6aa015.d2c5f3ac.webp";